// extracted by mini-css-extract-plugin
export default {"header":"header__OVZyn","hide":"hide__Sf65A","logoMobile":"logoMobile__rocp6","logoOther":"logoOther__sxgRG"};